module.exports = __webpack_public_path__ + "img/home.91a32cc0.svg";